import { HttpMethod } from '@guiker/http'

import { Lease } from '../../../entity'
import {
  GetLeaseDownloadLinkByScopeQueryParams,
  getLeaseDownloadLinkByScopeQueryParams,
} from '../../get-lease-download-link-by-scope'
import { leaseByScope } from '../../lease-by-scope'
import { leaseIdNested } from '../../lease-id-nested'
import { paths } from './paths'

const responseValidator = (payload: unknown) => Promise.resolve(payload as Lease)

export const routes = {
  getLeaseDownloadLinkByScope: {
    path: `${paths.lease.one.withScope()}/download`,
    method: HttpMethod.GET,
    authenticated: true,
    responseValidator,
    pathParamsValidator: (params: unknown) => leaseByScope.validate(params),
    queryParamsValidator: (params: unknown): Promise<Partial<GetLeaseDownloadLinkByScopeQueryParams>> =>
      getLeaseDownloadLinkByScopeQueryParams.validate(params),
  },
  readOneLease: {
    path: paths.lease.all.withId(':leaseId'),
    method: HttpMethod.GET,
    authenticated: true,
    responseValidator,
    pathParamsValidator: (params: unknown) => leaseIdNested.validate(params),
  },
  readOneLeaseByScope: {
    path: paths.lease.one.withScope(),
    method: HttpMethod.GET,
    authenticated: true,
    responseValidator,
    pathParamsValidator: (params: unknown) => leaseByScope.validate(params),
  },
}
